import { useSelector } from "react-redux";
import type { RootState } from "../../../../../../../redux/store";
import { getTicketDetailsRightSidebarItems } from "../utils/constants";

interface RightSidebarProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

export const RightSidebar = ({ activeTab, onTabChange }: RightSidebarProps) => {
  const region = useSelector(
    (state: RootState) => state?.auth?.client?.region
  );
  const sidebarItems = getTicketDetailsRightSidebarItems(region);

  return (
    <div className="flex flex-col items-center w-[70px] pt-0 py-[8px] shrink-0 h-full border-l border-border-gray dark:border-border-gray-dk bg-verba-pearl dark:bg-verba-pearl-dk">
      {sidebarItems?.map((item) => {
        const Icon = item?.icon;
        const isActive = activeTab === item?.id;

        return (
          <div
            key={item?.id}
            className={`relative p-[4px] w-full h-[60px] flex flex-col gap-[4px] justify-center items-center cursor-pointer ${
              isActive
                ? "bg-verba-blue dark:bg-verba-blue-dk hover:bg-verba-blue dark:hover:bg-verba-blue-dk"
                : "hover:bg-hover-effect dark:hover:bg-hover-effect-dk"
            }`}
            onClick={() => onTabChange(item?.id)}
          >
            {Icon && (
              <Icon
                className={`w-[18px] h-[18px] ${
                  isActive
                    ? "text-fixed-white-light-and-dark-mode dark:text-fixed-white-light-and-dark-mode-dk"
                    : "text-verba-indigo dark:text-verba-indigo-dk"
                }`}
              />
            )}
            <p
              className={`w-full text-center truncate text-xs font-normal ${
                isActive
                  ? "text-fixed-white-light-and-dark-mode dark:text-fixed-white-light-and-dark-mode-dk"
                  : "text-verba-indigo dark:text-verba-indigo-dk"
              }`}
            >
              {item?.label}
            </p>
          </div>
        );
      })}
    </div>
  );
};
